import React, { useEffect, useState } from 'react'
import VirtualRoomContainer from '../../components/VirtualRoom/VirtualRoomContainer'

const VirtualRoomPage = () => {
  return (<VirtualRoomContainer/>)
}

export default VirtualRoomPage